// extracted by mini-css-extract-plugin
export default {"accordion_control":"styles_accordion_control__Phxmx","control_title":"styles_control_title__N2fOz"};